/**
 * Blossom — marquee.js
 * <marquee-ticker> — continuous scrolling ticker (sections/icon-list.liquid).
 * The animation itself is CSS (.marquee in theme.css). This element adds a
 * pause/play control (WCAG 2.2.2), pauses while off screen, and leaves the
 * content static when the visitor prefers reduced motion.
 *
 * Markup: <marquee-ticker>
 *           <div class="marquee">…tracks…</div>
 *           <button data-marquee-toggle aria-pressed="false">…</button>
 *         </marquee-ticker>
 */
(() => {
  if (!window.Theme || customElements.get('marquee-ticker')) return;

  class MarqueeTicker extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.marquee');
      this.toggle = this.querySelector('[data-marquee-toggle]');
      if (!this.viewport || this.bound) return;
      this.bound = true;

      if (Theme.prefersReducedMotion()) {
        this.classList.add('is-static');
        if (this.toggle) this.toggle.hidden = true;
        return;
      }

      this.toggle?.addEventListener('click', () => this.setPaused(!this.userPaused));

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(([entry]) => {
          this.viewport.classList.toggle('is-paused', this.userPaused || !entry.isIntersecting);
        });
        this.observer.observe(this);
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    setPaused(paused) {
      this.userPaused = paused;
      this.viewport.classList.toggle('is-paused', paused);
      if (!this.toggle) return;
      // Constant label ("Pause scrolling text") + pressed state = accessible toggle.
      this.toggle.setAttribute('aria-pressed', String(paused));
    }
  }

  customElements.define('marquee-ticker', MarqueeTicker);
})();
